var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageExists)?_c('img',{class:'avatar-img ' + 'avatar-img-' + _vm.size,attrs:{"src":_vm.getImageSrc}}):_c('font-awesome-icon',{class:'avatar-placeholder avatar-placeholder-' + _vm.size + ' text-grey-light',attrs:{"icon":"user-circle"}})}
var staticRenderFns = []

export { render, staticRenderFns }